import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Center,
  HStack,
  Icon,
  Spinner,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { IoArrowRedoCircleOutline } from "react-icons/io5";
import { Editor } from "ckeditor5-custom-build-light/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const JournalEntryDialog = ({
  isOpen,
  onClose,
  isLoading,
  dateLabel,
  entryText,
  onGoToEdit,
}) => {
  const cancelRef = useRef();
  const iconColor = useColorModeValue("black", "white");
  const paperContentClass = useColorModeValue(
    "paper-content-light",
    "paper-content-dark"
  );

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered={true}
      closeOnOverlayClick={true}
      size="xl"
    >
      {isLoading ? (
        <AlertDialogOverlay>
          <AlertDialogContent>
            <Center p={8}>
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </Center>
          </AlertDialogContent>
        </AlertDialogOverlay>
      ) : (
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              <HStack w="100%" justify="space-between" align="center">
                <Center flex="1">Journal Entry on {dateLabel}</Center>
                <Tooltip label="Go To Edit" fontSize="sm" hasArrow>
                  <Button
                    p={0}
                    minW="auto"
                    h="auto"
                    colorScheme="white"
                    onClick={onGoToEdit}
                  >
                    <Icon
                      as={IoArrowRedoCircleOutline}
                      color={iconColor}
                      boxSize={6}
                      _hover={{ color: "gray.400" }}
                    />
                  </Button>
                </Tooltip>
              </HStack>
            </AlertDialogHeader>
            <AlertDialogBody paddingBottom={5}>
              <div className={`paper-content ${paperContentClass}`}>
                <CKEditor
                  editor={Editor}
                  data={entryText}
                  disabled={true}
                  onReady={(editor) => {
                    const originalDestroy = editor.destroy.bind(editor);
                    editor.destroy = () => {
                      try {
                        return originalDestroy().catch(() => {});
                      } catch (e) {
                        return Promise.resolve();
                      }
                    };
                  }}
                  onChange={() => {}}
                />
              </div>
            </AlertDialogBody>
          </AlertDialogContent>
        </AlertDialogOverlay>
      )}
    </AlertDialog>
  );
};

export default JournalEntryDialog;
